/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../../localization'
import { ModifyReservationInput } from '../../../../types/modifyReserveTAPanel'
import { AddOnForModify } from '../../../../types/searchAvailability'
import AddOnRow from './addOnRow'
import { useStyles } from './styles/index.styles'

type AddOnProps = {
  roomIndex: number
  data: AddOnForModify[]
  modifyReservationInput: ModifyReservationInput
  setModifyReservationInput: React.Dispatch<
    React.SetStateAction<ModifyReservationInput>
  >
}
const AddOn = ({
  roomIndex,
  data,
  modifyReservationInput,
  setModifyReservationInput
}: AddOnProps) => {
  const classes = useStyles()

  return (
    <div className={classes.tableContainer}>
      <div className={classes.tableHeader}>
        <Typography variant="h5" className={classes.headerText}>
          {getTranslate('Add-Ons')}
        </Typography>
        <Typography variant="h5" className={classes.headerTextExceptOne}>
          {getTranslate('Choice')}
        </Typography>
        <Typography variant="h5" className={classes.headerTextExceptOne}>
          {getTranslate('Add on price')}
        </Typography>
      </div>
      {data.map((addOn, i) => (
        <AddOnRow
          key={i}
          data={addOn}
          roomIndex={roomIndex}
          modifyReservationInput={modifyReservationInput}
          setModifyReservationInput={setModifyReservationInput}
        />
      ))}
    </div>
  )
}

export default AddOn
